import {useIntl} from 'react-intl'

function useGiftCardBalanceFields({
    form: {
        control,
        formState: {errors},
        watch
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        giftCardNumber: {
            name: `${prefix}giftCardNumber`,
            label: formatMessage({
                defaultMessage: 'Enter your Gift Card Number',
                id: 'useGiftCardFields.label.giftCardNumber'
            }),
            type: 'text',
            autoComplete: 'new-giftCardNumber',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter a gift card code.',
                    id: 'useGiftCardFields.label.giftCardNumber.error'
                })
            },
            error: errors[`${prefix}giftCardNumber`],
            control
        },
        pin: {
            name: `${prefix}pin`,
            label: formatMessage({
                defaultMessage: 'Enter your Gift Card Pin',
                id: 'useGiftCardFields.label.pin'
            }),
            type: 'text',
            autoComplete: 'new-pin',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter 4 digit gift card pin.',
                    id: 'useGiftCardFields.label.pin.error'
                })
            },
            error: errors[`${prefix}pin`],
            control
        },
        recaptcha: {
            name: `${prefix}recaptcha`,
            type: 'hidden', // or just omit in UI
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please verify that you are not a robot.',
                    id: 'use_registration_fields.error.invalid_recaptcha_message'
                }),
                validate: (value) => {
                    return (
                        (value && value.length > 0) ||
                        formatMessage({
                            defaultMessage: 'Please verify that you are not a robot.',
                            id: 'use_registration_fields.error.invalid_recaptcha_message'
                        })
                    )
                }
            },
            error: errors[`${prefix}recaptcha`],
            control
        }
    }

    return fields
}

export default useGiftCardBalanceFields
